var map = {
	"./aUsers.SVG": 932,
	"./advance.SVG": 536,
	"./advances.SVG": 7206,
	"./baggage.SVG": 2835,
	"./baggages.SVG": 9698,
	"./bell.SVG": 2312,
	"./book.SVG": 6229,
	"./bookings.SVG": 9424,
	"./bus.SVG": 2529,
	"./cab.SVG": 5396,
	"./cc.SVG": 9851,
	"./chat.SVG": 6124,
	"./coins.SVG": 5381,
	"./dashboard.SVG": 7784,
	"./filter.SVG": 2704,
	"./folder.SVG": 2508,
	"./grid.SVG": 8866,
	"./help.SVG": 4611,
	"./homes.SVG": 6687,
	"./inbox.SVG": 3355,
	"./logout.SVG": 514,
	"./map.SVG": 9773,
	"./maps.SVG": 9269,
	"./paper.SVG": 2542,
	"./paperstack.SVG": 9909,
	"./plane.SVG": 4829,
	"./receipts.SVG": 5062,
	"./requests.SVG": 5070,
	"./setting.SVG": 2844,
	"./settlement.SVG": 3915,
	"./stack.SVG": 2274,
	"./stay.SVG": 2492,
	"./taxi.SVG": 3436,
	"./teams.SVG": 9169,
	"./train.SVG": 4657,
	"./travels.SVG": 291,
	"./users.SVG": 5176,
	"./voucher.SVG": 2258,
	"./wallet.SVG": 101,
	"./warehouse.SVG": 3054
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7868;